import { DSPLoader } from 'components/DSPLoader/DSPLoader';
import { useParentAppName } from 'modules/taboola-common-frontend-modules/i18n/hooks/useParentAppName';
import { RealizeLoader } from '../../../../../components/RealizeLoader/RealizeLoader';

const loaderMap = {
    yahoo: DSPLoader,
};

export const useFormLoadingOverlayLoader = () => {
    const themeName = useParentAppName();

    return loaderMap[themeName] ?? RealizeLoader;
};
